export const stripeSecretKey = process.env.STRIPE_SECRET_KEY as string;
export const stripeWebhookSecret = process.env.STRIPE_WEBHOOK_SECRET as string;

export const stripeIdProductFirst = process.env
  .NEXT_PUBLIC_STRIPE_ID_PRODUCT_FIRST as string;
export const stripeIdProductSecond = process.env
  .NEXT_PUBLIC_STRIPE_ID_PRODUCT_SECOND as string;
export const stripeIdProductThird = process.env
  .NEXT_PUBLIC_STRIPE_ID_PRODUCT_THIRD as string;

export const stripeIdSubscriptionFirstMonthly = process.env
  .NEXT_PUBLIC_STRIPE_ID_SUBSCRIPTION_FIRST_MONTHLY as string;
export const stripeIdSubscriptionFirstYearly = process.env
  .NEXT_PUBLIC_STRIPE_ID_SUBSCRIPTION_FIRST_YEARLY as string;

export const stripeIdSubscriptionSecondMonthly = process.env
  .NEXT_PUBLIC_STRIPE_ID_SUBSCRIPTION_SECOND_MONTHLY as string;
export const stripeIdSubscriptionSecondYearly = process.env
  .NEXT_PUBLIC_STRIPE_ID_SUBSCRIPTION_SECOND_YEARLY as string;

export const stripeIdSubscriptionThirdMonthly = process.env
  .NEXT_PUBLIC_STRIPE_ID_SUBSCRIPTION_THIRD_MONTHLY as string;
export const stripeIdSubscriptionThirdYearly = process.env
  .NEXT_PUBLIC_STRIPE_ID_SUBSCRIPTION_THIRD_YEARLY as string;

export const stripeIdSubscriptionFirstYearlyBlackFriday = process.env
  .NEXT_PUBLIC_STRIPE_ID_SUBSCRIPTION_FIRST_YEARLY_BLACK_FRIDAY as string;
export const stripeIdSubscriptionSecondYearlyBlackFriday = process.env
  .NEXT_PUBLIC_STRIPE_ID_SUBSCRIPTION_SECOND_YEARLY_BLACK_FRIDAY as string;
export const stripeIdSubscriptionThirdYearlyBlackFriday = process.env
  .NEXT_PUBLIC_STRIPE_ID_SUBSCRIPTION_THIRD_YEARLY_BLACK_FRIDAY as string;

export const stripeIdSubscriptionEnterprises = [
  "price_1QM7YMKreVXxjBuY5WMD0aPG",
  "price_1QJAbiKreVXxjBuYj1eBgoie",
  "price_1Q7eYMKreVXxjBuYM3Qiauph",
  "price_1PlpQMKreVXxjBuY1IyEEf5L",
  "price_1Rh6JxKreVXxjBuYttKz5E8c",
  "price_1TUPBgKreVXxjBuYPurxZxpB",
];

export const namePublicSubscriptionFree = "Free";
export const namePublicSubscriptionFirst = "Starter";
export const namePublicSubscriptionSecond = "Pro";
export const namePublicSubscriptionThird = "Ultimate";
// Shown on the account page for any paying customer outside the self-serve catalog.
export const namePublicSubscriptionEnterprise = "Enterprise";

export const PRICE_ID_TO_SUBSCRIPTION_PLAN: Record<
  string,
  "ms" | "mp" | "mu" | "ys" | "yp" | "yu"
> = {
  [stripeIdSubscriptionFirstMonthly]: "ms",
  [stripeIdSubscriptionFirstYearly]: "ys",
  [stripeIdSubscriptionSecondMonthly]: "mp",
  [stripeIdSubscriptionSecondYearly]: "yp",
  [stripeIdSubscriptionThirdMonthly]: "mu",
  [stripeIdSubscriptionThirdYearly]: "yu",
  [stripeIdSubscriptionFirstYearlyBlackFriday]: "ys",
  [stripeIdSubscriptionSecondYearlyBlackFriday]: "yp",
  [stripeIdSubscriptionThirdYearlyBlackFriday]: "yu",
};

export const minutesFree = 15;
export const minutesSubscriptionFirst = 60;
export const minutesSubscriptionSecond = 180;
export const minutesSubscriptionThird = null;
export const startSimplySeconds = 10000000;

export const UNLIMITED_CONVERSION_TIME = -15;

export const numberOfCustomModelsFree = 0;
export const numberOfCustomModelsFirst = 1;
export const numberOfCustomModelsSecond = 3;
export const numberOfCustomModelsThird = 8;

export const numberOfMixedModelsFree = 3;
export const numberOfMixedModelsFirst = null;
export const numberOfMixedModelsSecond = null;
export const numberOfMixedModelsThird = null;

export const bonusFirstPlanSeconds = 1 * 60 * 60;
export const bonusSecondPlanSeconds = 20 * 60 * 60;
